import { SiteGroup } from '@models/account/site-group.model';

import { ApiAdapter } from './adapter';
import { SiteAdapter } from './site.adapter';

export class SiteGroupAdapter extends ApiAdapter<SiteGroup> {
  private siteAdapter: SiteAdapter = new SiteAdapter();

  get(json): SiteGroup {
    return new SiteGroup({
      name: json['name'],
      code: json['code'],
      sites: this.siteAdapter.list(json['sites'] || []),
      accountId: json['accountId'],
    });
  }
}
